(() => {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function initialize(root=document){
  root.querySelectorAll('[data-n4-announcement]').forEach(area=>{
   if(area.dataset.ready)return;area.dataset.ready='true';
   const slides=[...area.querySelectorAll('[data-n4-announcement-slide]')];
   if(slides.length<2)return;
   const pause=area.querySelector('[data-n4-announcement-pause]');
   let index=0,timer,exitTimer,hovered=false,focused=false,paused=false,activeAnimations=[];
   const enabled=()=>area.dataset.autoplay==='true'&&!reduced.matches;
   const schedule=()=>{
    clearTimeout(timer);
    if(enabled()&&!paused&&!hovered&&!focused&&!document.hidden&&area.isConnected)
     timer=setTimeout(()=>{show((index+1)%slides.length);schedule()},Number(area.dataset.interval)||5000);
   };
   const show=value=>{
    const previous=slides[index];
    activeAnimations.forEach(animation=>animation.cancel());activeAnimations=[];clearTimeout(exitTimer);
    slides.forEach(slide=>slide.removeAttribute('data-exiting'));
    index=value;
    slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==index));slide.inert=i!==index});
    if(previous!==slides[index]&&!reduced.matches){
     previous.setAttribute('data-exiting','');
     if(typeof previous.animate==='function'){
      const timing={duration:650,easing:'cubic-bezier(.22,.61,.36,1)'};
      activeAnimations=[previous.animate([{transform:'translateX(0)'},{transform:'translateX(-105%)'}],timing),
       slides[index].animate([{transform:'translateX(105%)'},{transform:'translateX(0)'}],timing)];
     }
     exitTimer=setTimeout(()=>{previous.removeAttribute('data-exiting');activeAnimations=[]},650);
    }
   };
   const sync=()=>{
    if(pause){pause.hidden=!enabled();const label=paused?pause.dataset.playLabel:pause.dataset.pauseLabel;pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',label);pause.textContent=label}
    schedule();
   };
   pause?.addEventListener('click',()=>{paused=!paused;sync()});
   area.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hovered=true;schedule()}});
   area.addEventListener('pointerleave',()=>{hovered=false;schedule()});
   area.addEventListener('focusin',()=>{focused=true;schedule()});
   area.addEventListener('focusout',e=>{focused=area.contains(e.relatedTarget);schedule()});
   const onMotion=()=>{activeAnimations.forEach(animation=>animation.cancel());activeAnimations=[];slides.forEach(slide=>slide.removeAttribute('data-exiting'));clearTimeout(exitTimer);sync()};
   document.addEventListener('visibilitychange',schedule);reduced.addEventListener('change',onMotion);
   area._n4Cleanup=()=>{clearTimeout(timer);clearTimeout(exitTimer);activeAnimations.forEach(animation=>animation.cancel());document.removeEventListener('visibilitychange',schedule);reduced.removeEventListener('change',onMotion)};
   show(0);sync();
  });
  root.querySelectorAll('[data-native-product]').forEach(area=>{
   if(area.dataset.n4Purchase)return;
   const original=area.querySelector('[data-product-submit]'),bar=area.querySelector('[data-n4-purchase]'),price=area.querySelector('[data-variant-price]');
   if(!original||!bar||!price||!window.IntersectionObserver)return;
   area.dataset.n4Purchase='true';
   const button=bar.querySelector('[data-n4-buy]'),display=bar.querySelector('[data-n4-price]');
   const sync=()=>{button.textContent=original.textContent;button.disabled=original.disabled;display.textContent=price.textContent;};
   const mutations=new MutationObserver(sync);
   mutations.observe(original,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
   mutations.observe(price,{subtree:true,childList:true,characterData:true});
   const footer=document.querySelector('.product-discovery') || document.querySelector('.n4-footer');let buyVisible=false,priceVisible=false,footerVisible=false;
   const visibility=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target===original)buyVisible=entry.isIntersecting;else if(entry.target===price)priceVisible=entry.isIntersecting;else footerVisible=entry.boundingClientRect.top < (entry.rootBounds?.bottom || innerHeight)});bar.hidden=buyVisible||priceVisible||footerVisible},{threshold:0});visibility.observe(original);visibility.observe(price);if(footer)visibility.observe(footer);
   button.addEventListener('click',()=>{if(!original.disabled)original.click()});sync();
   area._n4Cleanup=()=>{mutations.disconnect();visibility.disconnect()};
  });
  root.querySelectorAll('[data-n4-shop]').forEach(shop=>{
   if(shop.dataset.ready)return;shop.dataset.ready='true';
   const controls=shop.querySelector('[data-n4-filters]');
   if(!controls)return;
   const buttons=[...controls.querySelectorAll('button')],cards=[...shop.querySelectorAll('[data-product-type]')];
   if(cards.length<1||buttons.length<2)return;controls.hidden=false;
   buttons.forEach(button=>button.addEventListener('click',()=>{
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    cards.forEach(card=>card.hidden=Boolean(button.dataset.n4Filter)&&card.dataset.productType!==button.dataset.n4Filter);
    const status=shop.querySelector('[data-n4-count]');status.textContent=status.dataset.label+': '+cards.filter(c=>!c.hidden).length;
   }));
  });
  root.querySelectorAll('[data-n4-routine]').forEach(routine=>{
   if(routine.dataset.ready)return;routine.dataset.ready='true';
   const choices=routine.querySelector('[data-n4-choices]'),panels=[...routine.querySelectorAll('[data-n4-panel]')];
   if(!choices||!panels.length)return;choices.hidden=false;
   const buttons=[...choices.querySelectorAll('button')];
   function select(index){buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));panels.forEach((p,i)=>p.hidden=i!==index);if(!reduced.matches)panels[index].animate([{opacity:.6,transform:'translateY(5px)'},{opacity:1,transform:'none'}],{duration:180,easing:'ease-out'});}
   panels.forEach((p,i)=>p.hidden=i!==0);buttons.forEach((b,i)=>b.addEventListener('click',()=>select(i)));
   routine.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-n4-panel]');if(panel)select(panels.indexOf(panel))});
  });
  root.querySelectorAll('.n4-search').forEach(details=>{
   if(details.dataset.ready)return;details.dataset.ready='true';
   details.addEventListener('keydown',e=>{if(e.key==='Escape'){details.open=false;details.querySelector('summary').focus()}});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',e=>initialize(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-native-product],[data-n4-announcement]').forEach(area=>area._n4Cleanup?.()));
})();

(() => {
 function initialize(root=document){
  root.querySelectorAll('[data-n6-finder]').forEach(finder=>{
   if(finder.dataset.n6Ready)return;finder.dataset.n6Ready='true';
   const options=finder.querySelector('[data-n6-options]'),buttons=[...finder.querySelectorAll('[data-n6-choice]')],panels=[...finder.querySelectorAll('[data-n6-result]')];
   if(!options||buttons.length!==panels.length||!buttons.length)return;
   const choose=index=>{buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));panels.forEach((panel,i)=>panel.hidden=i!==index)};
   options.hidden=false;choose(0);
   buttons.forEach((button,i)=>button.addEventListener('click',()=>choose(i)));
   finder.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-n6-result]');if(panel)choose(panels.indexOf(panel))});
  });
  root.querySelectorAll('[data-n6-disclosure]').forEach(disclosure=>{
   if(disclosure.dataset.n6Ready)return;disclosure.dataset.n6Ready='true';
   disclosure.addEventListener('keydown',event=>{if(event.key==='Escape'){disclosure.open=false;disclosure.querySelector('summary').focus()}});
   disclosure.addEventListener('click',event=>{if(event.target.closest('a'))disclosure.open=false});
   disclosure.addEventListener('toggle',()=>{if(disclosure.open)root.querySelectorAll('[data-n6-disclosure]').forEach(other=>{if(other!==disclosure)other.open=false})});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();


/* Resize events, rather than scroll events, keep sticky offsets correct after text edits. */
(() => {
 const controllers = new Map();
 function initialize(root=document){
  const headers=[...(root.matches?.('.n6-header')?[root]:[]),...root.querySelectorAll('.n6-header')];
  headers.forEach(header=>{
   const section=header.closest('.n6-header-section');
   if(!section||controllers.has(section))return;
   const announcement=section.querySelector('[data-n4-announcement]');
   const measure=()=>{
    const announcementHeight=announcement?.getBoundingClientRect().height||0;
    const headerHeight=header.getBoundingClientRect().height;
    const sticky=header.dataset.n6Sticky==='true';
    section.style.setProperty('--n6-announcement-height',`${announcementHeight}px`);
    document.documentElement.style.setProperty('--n6-sticky-height',`${sticky?headerHeight:0}px`);
   };
   measure();
   let observer;
   if('ResizeObserver' in window){observer=new ResizeObserver(measure);observer.observe(header);if(announcement)observer.observe(announcement)}
   else window.addEventListener('resize',measure,{passive:true});
   controllers.set(section,()=>{observer?.disconnect();window.removeEventListener('resize',measure)});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
 document.addEventListener('shopify:section:unload',event=>{
  const dispose=controllers.get(event.target);if(dispose){dispose();controllers.delete(event.target)}
 });
})();
